import React from 'react';
import './ListViewItem.scss';
import ListViewItemPrimaryButton, {ListViewItemPrimaryButtonProps} from './ListViewItemPrimaryButton';

/**
 * Properties of the ListViewItem component.
 *
 * Since this whole component is basically just a wrapper around a ListViewItemPrimaryButton, we extend the
 * ListViewItemPrimaryButtonProps interface.
 */
export interface ListViewItemProps extends ListViewItemPrimaryButtonProps {
  hovering?: boolean;
}

const ListViewItem: React.FC<ListViewItemProps> = (props) => {
  const cssClassNames = ['listview-item'];
  if (props.hovering) {
    cssClassNames.push('listview-item--hover');
  }

  return <li className={cssClassNames.join(' ')}>
    <ListViewItemPrimaryButton {...props}/>
  </li>;
};

export default ListViewItem;
